import Lenis from '@studio-freight/lenis';

let lenisInstance = null;

export const initSmoothScroll = () => {
  // Prevent multiple instances
  if (lenisInstance) {
    lenisInstance.destroy();
  }

  const lenis = new Lenis({
    duration: 1.0,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    infinite: false,
  });

  lenisInstance = lenis;

  // Handle anchor link clicks to work with Lenis
  const handleAnchorClick = (e) => {
    const target = e.target.closest('a[href^="#"]');
    if (target) {
      const id = target.getAttribute('href');
      const element = document.querySelector(id);
      if (element) {
        e.preventDefault();
        lenis.scrollTo(element, { offset: 0, duration: 1.2 });
      }
    }
  };

  document.addEventListener('click', handleAnchorClick);

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // Store cleanup handler
  lenis._cleanupAnchor = () => document.removeEventListener('click', handleAnchorClick);

  return lenis;
};

export const getLenis = () => lenisInstance;
